// extracted by mini-css-extract-plugin
export var articleHeading = "news-module--articleHeading--3r_Ls";
export var articleQueryContent = "news-module--articleQueryContent--3vFza";
export var newsButton = "news-module--newsButton--LtnBy";
export var newsSection = "news-module--newsSection--2XpmE";
export var sectionLnSpItem = "news-module--sectionLnSpItem--1vNRu";
export var sectionItemNews = "news-module--sectionItemNews--1pTuj";